import type { ErrorInfo } from 'react'
import { ErrorBoundary, type ErrorBoundaryProps } from 'react-error-boundary'
import { BrowserLogCategory, DevLog } from '~sharedConfig'

export type AppAppErrorBoundaryProps = ErrorBoundaryProps

export const AppAppErrorBoundary = ({ onError, ...props }: AppAppErrorBoundaryProps) => {
	const handleOnError = (error: unknown, info: ErrorInfo) => {
		if (error instanceof Error)
			DevLog(BrowserLogCategory.Error, 'Render app error', error)
		else
			DevLog(BrowserLogCategory.Error, 'Render app error (non-Error)', error)

		DevLog(BrowserLogCategory.Error, 'Stack of render app error', info.componentStack)

		if (onError) onError(error, info)
	}

	return <ErrorBoundary {...props} onError={handleOnError} />
}
